var computeDaysSinceActive = function (activeSince) {
    if (!activeSince)
        return 0;
    var start = new Date(activeSince);
    if (Number.isNaN(start.getTime()))
        return 0;
    var now = new Date();
    var diffMs = now.getTime() - start.getTime();
    return Math.max(Math.floor(diffMs / (1000 * 60 * 60 * 24)), 0);
};
/** Maps API organizer data to display fields for the trip details card. */
export var mapOrganizerProfile = function (organizer) {
    var _a, _b, _c, _d, _e, _f, _g;
    var username = ((_a = organizer.username) === null || _a === void 0 ? void 0 : _a.trim()) ||
        ((_b = organizer.name) === null || _b === void 0 ? void 0 : _b.trim().toLowerCase().replace(/\s+/g, "-")) ||
        "user-".concat(organizer.id);
    return {
        id: organizer.id,
        name: organizer.name,
        username: username,
        title: ((_c = organizer.tagline) === null || _c === void 0 ? void 0 : _c.trim()) || "",
        bio: ((_d = organizer.bio) === null || _d === void 0 ? void 0 : _d.trim()) || "",
        profileImageUrl: organizer.profileImageUrl,
        daysSinceActive: computeDaysSinceActive(organizer.activeSince),
        isVerified: (_e = organizer.isVerified) !== null && _e !== void 0 ? _e : false,
        linkedinUrl: ((_f = organizer.linkedinUrl) === null || _f === void 0 ? void 0 : _f.trim()) || undefined,
        instagramUrl: ((_g = organizer.instagramUrl) === null || _g === void 0 ? void 0 : _g.trim()) || undefined,
        isOrganization: organizer.isOrganization,
    };
};
